const state = {
  products: [],
  categoryName: '',
  pagy: {}
};

const mutations = {
  SET_PRODUCTS(state, products) {
    state.products = products;
  },
  APPEND_PRODUCTS(state, products) {
    state.products = [...state.products, ...products];
  },
  SET_CATEGORY_NAME(state, categoryName) {
    state.categoryName = categoryName;
  },
  SET_PAGY(state, pagy) {
    state.pagy = pagy;
  }
};

const actions = {
  fetchProducts({ commit, rootState }, { params, append = false }) {
    return rootState.api
      .fetchProducts({
        ...params,
        widget_id: rootState.widget.widget.id
      })
      .then(({ data }) => {
        commit(append ? 'APPEND_PRODUCTS' : 'SET_PRODUCTS', data.products);
        commit('SET_CATEGORY_NAME', data.category_name);
        commit('SET_PAGY', data.pagy);
        commit('widget/SET_HAS_MINIMUM_ITEMS', data.has_minimum_products, {
          root: true
        });
      });
  }
};

export default { namespaced: true, state, mutations, actions };
